import { Component } from '@angular/core';
import { CheckboxFilterField } from './filter-field-checkbox';
import { FilterFieldComponent } from '../filter-field.component';

@Component({
  selector: 'va-filter-checkbox',
  styleUrls: ['./filter-field-checkbox.scss'],
  template: `
    <mat-checkbox
      class="checkbox"
      color="primary"
      [checked]="filterField.value"
      (change)="applyFilter(!filterField.value)"
    ></mat-checkbox>
    <span class="filter-name" (click)="applyFilter(!filterField.value)">
      <img
        *ngIf="filterField.icon"
        class="filter-name-icon"
        [src]="filterField.icon?.url"
        [width]="filterField.icon?.width"
        [height]="filterField.icon?.height"
      />
      {{
        '' + (filterField.disableTranslation ? filterField.name : (filterField.name | translate)) + filterField.suffix
      }}
    </span>
  `,
})
export class CheckboxFilterFieldComponent extends FilterFieldComponent<CheckboxFilterField> {}
